import DoctorPatients from '../../doctor/patients/Patients';

const ClinicPatients = () => {
  return <DoctorPatients />;
};

export default ClinicPatients;
